import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter13 extends Component {
  static displayName = Chapter13.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—13: अंतिम वर्षों की दिव्य लीला और अमर संदेश 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
               समय के साथ गुरुदेव स्वामी ब्रह्मानंद सरस्वती जी का जीवन एक शांत झील की तरह स्थिर होता गया। उनके भीतर तपस्या का तेज पहले जैसा ही था, लेकिन उसके ऊपर छाई हुई करुणा और शांत गंभीरता उन्हें बिल्कुल अद्वितीय बना रही थी।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            {/* <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>श्मशान में की गई उनकी कठोर तपस्या।</h3> */}
            
            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>1. अंतिम वर्षों में—तेज का शांत रूप</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव के जीवन के आख़िरी वर्षों में उनकी दिनचर्या बेहद सरल परंतु अत्यंत दिव्य हो गई थी।
              वह कम बोलते थे, अधिक मुस्कुराते थे, और अधिकांश समय ध्यान में लीन रहते थे।
              जो भी उनके पास आता— पीड़ित, दुखी, निराश या दिशाहीन— वह केवल एक बार उनके चरणों में बैठ लेता, तो जैसे उसके भीतर वर्षों से जमा हुआ बोझ तत्काल हल्का हो जाता।
              उनके चेहरे पर एक अद्भुत शांति थी— मानो उन्होंने संसार के पार छिपे किसी और जगत को देख लिया हो।
              अंतिम दिनों में उन्होंने बाहरी कार्य अत्यंत कम कर दिए, लेकिन भीतर की चेतना पहले से कहीं अधिक तेजस्वी हो गई।
              गुरुदेव कहते थे— “जब भीतर का दीपक स्वयं जलने लगे, तब बाहरी दीए की आवश्यकता समाप्त हो जाती है।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>2. महाप्रयाण से पहले के सूक्ष्म संकेत</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              महापुरुष अपने प्रस्थान से पहले अक्सर संकेत दे जाते हैं—पर वे संकेत सिर्फ वही समझ पाते हैं जो उनके निकट रहते हैं।
              <br/><br/>
              गुरुदेव ने भी कई सूक्ष्म लक्षण दिखाए—<br/>
                ● (1) उन्होंने अपने ग्रंथों को स्वयं क्रमबद्ध कराया एक दिन अचानक उन्होंने आश्रम के ब्रह्मचारियों से कहा— “मेरी लिखी हर पंक्ति अब दूसरों के लिए है। मुझे जो समझना था, वह मैं समझ चुका।”<br/>
                इसके बाद उन्होंने स्वयं अपने ग्रंथों, नोट्स और उपदेशों को क्रम में लगवाया, मानो किसी को अदृश्य रूप से सौंप रहे हों।<br/><br/>

                ● (2) सभी शिष्यों को अपने पास बुलाया कई वर्षों से दूर रह रहे शिष्य अचानक आश्रम पहुँचने लगे। जैसे कोई भीतर से खिंचकर उन्हें बुला रहा हो।<br/>
                गुरुदेव उनसे मिलते समय अक्सर बस इतना कहते— “जो करना है, अभी कर लो… समय कम है।” उस समय किसी को समझ नहीं आया कि वे किस समय की बात कर रहे हैं।<br/><br/>

                ● (3) भोजन, निद्रा और वाणी में अचानक परिवर्तन आख़िरी महीनों में वह बहुत कम भोजन करने लगे, रात में बहुत कम सोते, और कभी-कभी घंटों तक एकदम मौन होकर बैठे रहते।<br/>
                एक दिन उनके सबसे नज़दीकी शिष्य ने पूछा— “गुरुदेव, क्या आप ठीक हैं?” गुरुदेव मुस्कुराए और बोले— “मैं पूर्णतया ठीक हूँ। अब यह शरीर थोड़ा-सा काम बचा कर रहा है।” उनकी आँखों में उस क्षण अद्भुत प्रकाश था, जैसे किसी ने भीतर छिपे सभी रहस्यों का द्वार खोल दिया हो।<br/><br/>

                ● (4) अंतिम संकेत — पूर्ण मौन महाप्रयाण से कुछ दिन पहले उन्होंने बोलना लगभग बंद कर दिया। पर आश्रम में सब जानते थे— उनका मौन अंत नहीं, बल्कि पूर्णता का संकेत है। उनकी उपस्थिति ही वाणी बन गई थी। जो उनके दरबार में आता, बिना शब्दों के ही गुरुदेव से अपना उत्तर पा लेता।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>3. महाप्रयाण — मौन की उस अंतिम साँस में अनंत का स्पर्श</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              फिर वह पावन दिन आया जब प्रकृति स्वयं जैसे रुक गई थी। उस सुबह गुरुदेव पहले से कहीं अधिक शांत दिखाई दे रहे थे। उन्होंने धीरे से आँखें बंद कीं, कुछ क्षण अपने शिष्यों की ओर देखा और हल्का-सा मुस्कुराए—

            जैसे कह रहे हों— “घबराना मत। जो मैं हूँ, वह यहाँ से नहीं जा रहा।”

            कुछ ही मिनटों में उनका श्वास धीमा हुआ, फिर और धीमा… और अंततः अतिशय शांति की एक लहर में गुरुदेव का महाप्रयाण हो गया।

            आश्रम में कोई रोया नहीं— आँखें नम थीं, लेकिन भीतर किसी को लगा कि गुरुदेव कहीं गए नहीं हैं— बल्कि सारे ब्रह्मांड में फैल गए हैं।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>4. गुरुदेव का अंतिम आध्यात्मिक संदेश</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव ने अपनी अंतिम शिक्षा किसी ग्रंथ में नहीं लिखी थी। वह शिष्यों को मौन में दी गई थी, किन्तु बाद में सभी ने उसे शब्दों में उतारा। वह संदेश था— “मन को प्रकाश दो। अहंकार को खाली करो। और प्रेम को अपना धर्म बना लो। बाक़ी सब स्वयं घटित हो जाएगा।” उन्होंने कहा था— “शक्ति साधना का लक्ष्य नहीं, प्रेम साधना का लक्ष्य है।” और यह भी— “जिस दिन तुम अपने भीतर दूसरों के दुख को महसूस करने लगो समझ लेना कि उस दिन तुम्हारी साधना सफल हो गई।” गुरुदेव की अंतिम वाणी में सिर्फ यही सार बचा था— “साधना का अर्थ है— ईश्वर को देखना नहीं, ईश्वर जैसा बन जाना।” और उसी संदेश के साथ गुरुदेव का शरीर तो संसार से चला गया, लेकिन उनकी चेतना उसी क्षण अनेक शिष्यों के भीतर जागृत हो उठी।
            </p>

            
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter12" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}